import React from "react";
import { Button, Form, Modal } from "reactstrap";

const ActiveMerchantPGModal = ({ isViewsendDataModal, onCloseModal, data }) => {
  return (
    <Form>
      <Modal
        isOpen={!!isViewsendDataModal}
        toggle={() => onCloseModal()}
        className="modal-lg"
        centered={true}
      >
        <div className="modal-header">
          <h3 className="modal-title mt-0">
            Merchant PG label ({data?.merchantName})
          </h3>
          <i
            onClick={() => {
              onCloseModal();
            }}
            className="fa-solid fa-xmark"
          ></i>
        </div>
        <div className="modal-body w-100">
          {Object?.values?.(data?.pg_label || {})?.length ? (
            <div className="d-flex flex-column gap-1">
              {Object.entries?.(data?.pg_label || {})?.map?.(([k, v]) => {
                return (
                  <div className="d-flex flex-column">
                    <div className="bold">{k}</div>
                    {v?.map?.((label, idx) => {
                      return <small key={idx} className="text-gray-500">{label}</small>;
                    })}
                  </div>
                );
              })}
            </div>
          ) : (
            "No data found"
          )}
        </div>
        <div className="modal-footer">
          <div className="d-flex justify-content-end button-space">
            <Button className="graybutton" onClick={() => onCloseModal()}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Form>
  );
};

export default ActiveMerchantPGModal;
